import moment from 'moment'

const MONTH_NAMES = {
	pl: [
		'styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec',
		'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień',
	],
	en: [
		'January', 'February', 'March', 'April', 'May', 'June',
		'July', 'August', 'September', 'October', 'November', 'December',
	],
}

export const toDateInputValue = value => {
	if (!value) return ''
	const date = moment(value)
	return date.isValid() ? date.format('YYYY-MM-DD') : ''
}

export const formatDisplayDate = value => {
	if (!value) return '—'
	const date = moment(value)
	return date.isValid() ? date.format('DD.MM.YYYY') : '—'
}

export const getMonthLabel = (startDate, i18n) => {
	const locale = (i18n.resolvedLanguage || i18n.language || 'en').startsWith('pl') ? 'pl' : 'en'
	const monthIndex = moment(startDate).month()
	const year = moment(startDate).year()
	const monthLabel = MONTH_NAMES[locale][monthIndex] || ''
	return monthLabel ? `${monthLabel.charAt(0).toUpperCase()}${monthLabel.slice(1)} ${year}` : ''
}

const toDateKey = value => {
	const date = `${value || ''}`.substring(0, 10)
	return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : ''
}

const relationId = value => {
	if (!value) return ''
	if (typeof value === 'object') return `${value._id || value.id || value.userid || ''}`.trim()
	return `${value}`.trim()
}

const stepAssignedToUser = (step, userId) => {
	const pozycje = Array.isArray(step?.pozycje) ? step.pozycje : []
	return pozycje.some(item => relationId(item?.trainerId) === `${userId}`)
}

export const buildProjectCalendarItems = (projects, userId) => {
	const seen = new Set()
	const items = []

	;(Array.isArray(projects) ? projects : []).forEach(project => {
		const projectId = relationId(project?._id || project?.id)
		if (!projectId || !userId) return

		const steps = Array.isArray(project.steps) ? project.steps : []
		steps.forEach(step => {
			if (!stepAssignedToUser(step, userId)) return

			const start = toDateKey(step?.data_rozpoczecia)
			const end = toDateKey(step?.data_zakonczenia) || start
			if (!start) return

			const key = `${projectId}|${start}|${end}`
			if (seen.has(key)) return
			seen.add(key)

			items.push({
				_id: key,
				projectId,
				trainingName: `${project?.nazwa || step?.nazwa || ''}`.trim() || '—',
				trainingDate: start,
				trainingEndDate: end,
			})
		})
	})

	return items
}

export const filterTrainingsByRange = (items, start, end) => {
	const startMoment = moment(start, 'YYYY-MM-DD', true)
	const endMoment = moment(end, 'YYYY-MM-DD', true)

	return (Array.isArray(items) ? items : []).filter(item => {
		const itemStart = moment(item?.trainingDate || item?.data_rozpoczecia)
		const itemEnd = moment(
			item?.trainingEndDate || item?.data_zakonczenia || item?.trainingDate || item?.data_rozpoczecia
		)

		if (!itemStart.isValid() || !itemEnd.isValid()) return false
		if (startMoment.isValid() && itemEnd.isBefore(startMoment, 'day')) return false
		if (endMoment.isValid() && itemStart.isAfter(endMoment, 'day')) return false
		return true
	})
}

export const buildEmptyFormState = anchorDate => ({
	dateFrom: anchorDate || '',
	dateTo: anchorDate || '',
	slots: [],
	notes: '',
})

export const availabilityToFormState = item => ({
	dateFrom: toDateInputValue(item?.startDate || item?.dateFrom),
	dateTo: toDateInputValue(item?.endDate || item?.dateTo || item?.startDate || item?.dateFrom),
	slots: Array.isArray(item?.slots) ? item.slots : [],
	notes: item?.notes || '',
})

export const buildDetailsTitle = (availability, t) => {
	const dateFromLabel = formatDisplayDate(availability?.startDate || availability?.dateFrom)
	const dateToLabel = formatDisplayDate(availability?.endDate || availability?.dateTo)
	return dateFromLabel === dateToLabel
		? t('trainingAvailability.details.headerTitleSingle', { date: dateFromLabel })
		: t('trainingAvailability.details.headerTitleRange', { startDate: dateFromLabel, endDate: dateToLabel })
}

export const isValidDateRange = (dateFrom, dateTo) => {
	const start = moment(dateFrom, 'YYYY-MM-DD', true)
	const end = moment(dateTo, 'YYYY-MM-DD', true)
	return start.isValid() && end.isValid() && !end.isBefore(start, 'day')
}
